import {initHeader} from "./Components/Header";
import "./elements/contact-bar";
import {initGallerySlider} from "./elements/gallery-slider";
import {initWeatherWidget} from "./elements/weather-widget";
import {initSideGallery} from "./nodetypes/sidegallery";
import "./nodetypes/bus";
import {initBlog} from "./nodetypes/blog";

import "./functions.js";
import "./../../../../NodeTypes/index.js";

window.addEventListener("DOMContentLoaded", () => {
  initHeader();
});

window.addEventListener("load", () => {
  initGallerySlider();
  initWeatherWidget();
  initSideGallery();
  initBlog();
}, {passive: true});
